<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <v-app>
                <v-form @submit.prevent="confirm">
                    <md-card>
                        <md-card-header class="md-card-header-icon md-card-header-green">
                            <div class="card-icon">
                                <md-icon>fact_check</md-icon>
                            </div>
                            <h4 class="title">系统元件信息</h4>
                        </md-card-header>
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item md-size-90 mx-auto">
                                    <v-text-field v-model="form.name" label="系统元件名称 *" :rules="[v => !!v || '系统元件名称不能为空']"></v-text-field>
                                    <v-select v-model="form.course" :items="courseList" item-text="name" item-value="_id" label="课程*" :rules="[v => !!v || '课程不能为空']" @change="filterProject"></v-select>
                                    <v-select v-model="form.project" :items="projectList" item-text="name" item-value="_id" label="项目*" :rules="[v => !!v || '项目不能为空']" :disabled="projectDisabled"></v-select>
                                </div>
                                <div class="md-layout-item md-size-90 mx-auto" style="padding-top: 20px">
                                    <md-toolbar class="md-small md-success">
                                        <div class="md-toolbar-row">
                                            <div class="md-toolbar-section-start">
                                                <h4 class="md-title">动作列表</h4>
                                            </div>
                                            <div class="md-toolbar-section-end">
                                                <md-button class="md-success" @click.native="handleAdd()">
                                                    <md-icon>add_circle</md-icon>新增
                                                </md-button>
                                            </div>
                                        </div>
                                    </md-toolbar>
                                    <ActionTable :list="tableData" @handleEdit="handleEdit" @handleDelete="handleDelete" />
                                    <md-card-actions md-alignment="right" style="margin-right: 0px">
                                        <md-button class="md-success" type="submit">确定</md-button>
                                        <md-button class="md-success" @click="back">返回</md-button>
                                    </md-card-actions>
                                </div>
                            </div>
                        </md-card-content>
                        <ActionForm :showAddDialog="showAddDialog" :formData="actionFormData" :index="handleIndex" @handleConfirm="handleConfirm" @handleCancel="handleCancel" />
                    </md-card>
                </v-form>
            </v-app>
        </div>
    </div>
</template>
<script>
import {
    insertSysComponent,
    updateSysComponent,
} from "@/api/component/sys_component";
import { listCourse } from "@/api/course";
import { listProject } from "@/api/project";
import ActionForm from "./Action/ActionForm";
import ActionTable from "./Action/ActionTable";
import Swal from "sweetalert2";
import { SlideYDownTransition } from "vue2-transitions";

export default {
    components: {
        ActionForm,
        ActionTable,
        SlideYDownTransition,
    },
    data() {
        return {
            sys_meta_name: "用户交互",
            sysact: "",
            uitype: "",
            replay: "",
            currentSort: "name",
            currentSortOrder: "asc",
            showAddDialog: false,
            form: {},
            actionFormData: {},
            courseList: [],
            projectList: [],
            default_value: "",
            scene_obj: {},
            handleIndex: -1,
            tableData: [],
            projectDisabled: true,
        };
    },
    methods: {
        async filterProject(item) {
            const projectResult = await listProject({
                course: item._id,
                perPage: 500,
            });
            if (projectResult.code == 200) {
                this.projectList = projectResult.data.rows;
                this.projectDisabled = false;
            }
        },
        async init() {
            const courseResult = await listCourse();
            const projectResult = await listProject();
            if (courseResult.code == 200) {
                this.courseList = courseResult.data.rows;
            }
            if (projectResult.code == 200) {
                this.projectList = projectResult.data.rows;
            }
            if (this.$route.query._id) {
                this.form = this.$route.query;
                this.tableData = this.form.action_list ? this.form.action_list : [];
                this.projectDisabled = false;
            }
        },
        async confirm() {
            this.form.action_list = this.tableData;
            const result = this.$route.query.name ?
                await updateSysComponent(this.form) :
                await insertSysComponent(this.form);
            if (result.code == 200) {
                this.$notify({
                    timeout: 1500,
                    message: "操作成功！",
                    icon: "add_alert",
                    horizontalAlign: "center",
                    verticalAlign: "bottom",
                    type: "success",
                });
                this.back();
            } else {
                this.$notify({
                    timeout: 1500,
                    message: "操作失败",
                    horizontalAlign: "center",
                    verticalAlign: "bottom",
                    type: "warning",
                });
            }
        },
        back() {
            this.$router.push({ path: "./systemmeta" });
        },
        handleConfirm(e) {
            this.showAddDialog = false;
            if (e.index === -1) {
                this.tableData.push(e.form);
                return;
            }
            this.tableData[e.index] = e.form;
        },
        handleCancel() {
            this.showAddDialog = false;
        },
        handleAdd() {
            this.showAddDialog = true;
            this.handleIndex = -1;
            this.actionFormData = {};
        },
        handleEdit(index) {
            this.showAddDialog = true;
            this.handleIndex = index;
            this.actionFormData = this.tableData[index];
        },
        handleDelete(index) {
            Swal.fire({
                title: "删除信息",
                text: `确认删除？移除后提交修改将不能恢复！`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success btn-fill",
                cancelButtonClass: "md-button md-danger btn-fill",
                confirmButtonText: "确 定",
                cancelButtonText: "取 消",
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.tableData.splice(index, 1);
                    this.$notify({
                        timeout: 1500,
                        message: "操作成功！",
                        icon: "add_alert",
                        horizontalAlign: "center",
                        verticalAlign: "bottom",
                        type: "success",
                    });
                }
            });
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery(value) {
            let result = this.tableData;
            if (value !== "") {
                result = this.fuseSearch.search(this.searchQuery);
            }
            this.searchedData = result;
        },
    },
};
</script>
<style lang="css" scoped>
.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}

.md-toolbar {
    padding: 0px 15px;
}

.alert.alert-with-icon {
    margin-top: 10px;
    padding-left: 10px;
}
</style>